var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import IconBase from '../components/IconBase';
import multiToneButtonReuse3Json from '../json/multiTone-button-reuse3.json';
var RefIcon = React.forwardRef(function (props, ref) { return React.createElement(IconBase, __assign({}, props, { svgJson: multiToneButtonReuse3Json, ref: ref })); });
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'MultiToneButtonReuse3';
}
export default RefIcon;
